.Ellipsis1944453712__root {
    -st-states: hasEllipsis;
}

.Ellipsis1944453712__root.Ellipsis1944453712--hasEllipsis {
    --Ellipsis1944453712-maxLines: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: var(--Ellipsis1944453712-maxLines);
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

/* st-namespace-reference="../../../../src/atoms/Ellipsis/Ellipsis.st.css" */